import {
	Box,
	Button,
	CardContainer,
	MarkdownRenderer,
	TextSkeleton,
} from "@memorang/ui";
import { useTranslation } from "react-i18next";
import { Card, TouchableRipple } from "react-native-paper";
import { useAppTheme } from "../useAppTheme";

type Props = {
	sessionAnalysis?: string;
	loading?: boolean;
	toggleShowCompleteReport: () => void;
	appFont?: string;
	title?: string;
	subtitle?: string;
	icon?: string;
	contentHeight?: number;
	textLimit?: number;
	actionLabel?: string;
};

const SessionAnalysisCard = ({
	sessionAnalysis = "",
	loading = false,
	toggleShowCompleteReport,
	appFont,
	title,
	subtitle,
	icon,
	contentHeight = 150,
	textLimit = 330,
	actionLabel,
}: Props) => {
	const _theme = useAppTheme();
	const { t } = useTranslation();
	const DefaultContent = () => {
		const truncateThreshold = textLimit + 70;
		const truncatedText =
			sessionAnalysis?.length > truncateThreshold
				? `${sessionAnalysis?.substring(0, textLimit)}...`
				: sessionAnalysis;

		return (
			<Card.Content
				style={{
					paddingHorizontal: 16,
					height: contentHeight,
					overflow: "hidden",
					paddingTop: 8,
				}}
			>
				<MarkdownRenderer
					text={truncatedText}
					variant="explanation"
					appFont={appFont}
				/>
			</Card.Content>
		);
	};

	return (
		<CardContainer
			title={title ?? t("report.sessionAnalysis.title")}
			subtitle={subtitle ?? t("report.sessionAnalysis.subtitle")}
			icon={icon ?? "head-lightbulb-outline"}
			actions={
				<Card.Actions>
					<Button onPress={toggleShowCompleteReport} mode="text">
						{actionLabel ?? t("report.sessionAnalysis.viewFullAnalysis")}
					</Button>
				</Card.Actions>
			}
		>
			<TouchableRipple
				onPress={toggleShowCompleteReport}
				rippleColor={"transparent"}
			>
				{loading || !sessionAnalysis ? (
					<Box
						paddingVertical={16}
						paddingHorizontal={16}
						height={contentHeight}
						alignItems="center"
					>
						<TextSkeleton numLines={4} height={18} />
					</Box>
				) : (
					<DefaultContent />
				)}
			</TouchableRipple>
		</CardContainer>
	);
};

export default SessionAnalysisCard;
